export const CreditPricing =
    [
        {values: 10000, price: 0.001},
        {values: 50000, price: 0.0009},
        {values: 100000, price: 0.0008},
        {values: 500000, price: 0.0007},
        {values: 1000000, price: 0.0005},
    ]
